import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=97059a0e&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=97059a0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97059a0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97059a0e')) {
      api.createRecord('97059a0e', component.options)
    } else {
      api.reload('97059a0e', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=97059a0e&scoped=true&", function () {
      api.rerender('97059a0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2XIXAN5488smZ/JS/comp/GuestBox.vue"
export default component.exports